module.exports = __webpack_public_path__ + "img/BS.5a65cc77.png";